<template>
  <transition name="fade" appear>
    <div class="my-trips content-wrapper">
      <AmexMainMenu />
      <div class="mobile-wrapper">
        <div class="mobile-overlay" v-if="isAmex">
          <div class="img"></div>
          <div class="text-primary"><b>Access AMEX Trip Planner from your desktop browser</b></div>
          <div class="text-secondary">
            Mobile devices are currently not supported. Plan your next trip from your web browser on your computer or
            laptop.
          </div>
        </div>
        <div class="my-trips__top">
          <Header></Header>
        </div>
        <div class="my-trips__content">
          <Card
            v-for="trip in myTrips"
            :key="trip.id"
            :isLoading="false"
            class="trip-card"
            :trip="trip"
            @click="openTrip(trip)"
          />
          <Start />
        </div>
        <Details
          id="my-trips-details-view"
          v-if="selectedTrip !== null"
          :trip="selectedTrip"
          @close="selectedTrip = null"
        />
        <PoweredByMobiFooter v-if="isFooterAvailable" class="full-width padded-top" />
      </div>
    </div>
  </transition>
</template>

<script>
import Header from './my-trips-header.vue';
import Card from './my-trips-card.vue';
import Details from './my-trips-details.vue';
import Start from './my-trips-start.vue';
import {dropMyTrips, fetchMyTrips, getMyTrips} from '@/store/state/helpers';
import AmexMainMenu from '../main-menu/main-menu.vue';
import PoweredByMobiFooter from '@common/powered-by-mobi-footer.vue';
import PilotEndsModal from '@common/modal/pilot-ends-modal.vue';

// @ts-ignore
import MdModalDialog from 'vue-material-modal-dialog';
import 'vue-material-modal-dialog/dist/components.css';
// @ts-ignore
import {MdDialog} from 'vue-material/dist/components';
import Vue from 'vue';

Vue.use(MdDialog);
Vue.use(MdModalDialog);

export default {
  name: 'AmexMyTrips',
  components: {
    Card,
    Details,
    Header,
    Start,
    AmexMainMenu,
    PoweredByMobiFooter,
  },
  data() {
    return {
      isAmex: process.env.VUE_APP_THEME === 'AMEX',
      selectedTrip: null,
      isFooterAvailable: process.env.VUE_APP_IS_FOOTER_VISIBLE || false,
    };
  },
  computed: {
    myTrips() {
      return getMyTrips().filter((x) => !x.autoSaved);
    },
  },
  mounted() {
    dropMyTrips();
    fetchMyTrips();
    if (this.isAmex) {
      const app = document.querySelector('#app');
      app.inert = true;
      this.$modal
        .show(PilotEndsModal, {size: 'sm'})
        .catch(() => null)
        .finally(() => {
          app.inert = false;
        });
    }
  },
  methods: {
    async openTrip(trip) {
      this.selectedTrip = trip;

      await this.$nextTick();

      this.$scrollTo('#my-trips-details-view', 500);
    },
  },
};
</script>

<style lang="scss">
.my-trips {
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  &__top {
    // width: 1240px;
    margin: 40px auto;
  }

  &__content {
    display: flex;
    // grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    flex-wrap: wrap;
    // width: 1240px;
    margin: 40px auto;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s linear;
    opacity: 1;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .padded-top {
    margin-top: auto;
  }
}
</style>
